import { CommonLogger, LogLevel } from '@evinced-private/ui-common';

const remoteLogLevelConfig = import.meta.env.VITE_SERVER_LOG_LEVEL;
const consoleLogLevelConfig = import.meta.env.VITE_CONSOLE_LOG_LEVEL;
const papertrailToken = import.meta.env.VITE_LOGS_PAPERTRAIL_TOKEN;
const remoteLogLevelThreshold = LogLevel[remoteLogLevelConfig as keyof typeof LogLevel];
const consoleLogLevelThreshold = LogLevel[consoleLogLevelConfig as keyof typeof LogLevel];
const hostname = window.location.host;
const productName = 'site-scanner';

const logger = new CommonLogger();

logger.init({
	papertrailToken,
	remoteLogLevelThreshold,
	consoleLogLevelThreshold,
	productName,
	hostname
});

export { logger };
